export enum SagepayEndpoints {
    PostSagepayProcess = '/v1/sagepay/process',
    PostSagepayProcessMicroPayment = '/v1/sagepay/process-micro',
}
